export default __webpack_public_path__ + "static/media/gallery_08.bae165f5.jpg";